const uspData = [
  {
    image: "images/ic1-1.png",
    title: "Expertise and Experience",
    description:
      "With 13 years of experience in the industry, we have developed a deep understanding of the complexities of water purifiers. Our team of experts is equipped with the latest knowledge and technologies to provide the most efficient and effective solutions."
  },
  {
    image: "images/ic2.png",
    title: "Prompt and Efficient Service",
    description:
      "We understand the importance of having a functional water purifier at all times. Our technicians diagnose and fix issues quickly, ensuring access to clean and safe drinking water."
  },
  {
    image: "images/ic3.png",
    title: "Customer Satisfaction",
    description:
      "Our commitment to customer satisfaction sets us apart. We strive to exceed expectations and provide exceptional service backed by a satisfaction guarantee."
  }
];

export default uspData;